module.exports = __webpack_public_path__ + "img/icons-general-protection.597c92c4.svg";